import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AutocompleteInputComponent} from "./autocomplete-input.component";
import {MatInputModule} from "@angular/material/input";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {ReactiveFormsModule} from "@angular/forms";



@NgModule({
   declarations: [
      AutocompleteInputComponent
   ],
   exports:[
      AutocompleteInputComponent
   ],
   imports: [
      CommonModule,
      MatInputModule,
      MatAutocompleteModule,
      ReactiveFormsModule
   ]
})
export class AutocompleteInputModule { }
